function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#00AAE1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36 39.9999C38.2091 39.9999 40 38.2091 40 35.9999C40 33.7908 38.2091 31.9999 36 31.9999C33.7909 31.9999 32 33.7908 32 35.9999C32 38.2091 33.7909 39.9999 36 39.9999Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.25 23.5001L29.9625 26.0001H26C24.625 26.0001 23.5 27.1251 23.5 28.5001V43.5001C23.5 44.8751 24.625 46.0001 26 46.0001H46C47.375 46.0001 48.5 44.8751 48.5 43.5001V28.5001C48.5 27.1251 47.375 26.0001 46 26.0001H42.0375L39.75 23.5001H32.25ZM36 42.2501C32.55 42.2501 29.75 39.4501 29.75 36.0001C29.75 32.5501 32.55 29.7501 36 29.7501C39.45 29.7501 42.25 32.5501 42.25 36.0001C42.25 39.4501 39.45 42.2501 36 42.2501Z",
  fill: "white"
});

function SvgCapture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapture);
export default __webpack_public_path__ + "static/media/capture.08ee63eb.svg";
export { ForwardRef as ReactComponent };